(function() {
  'use strict';

  var CLOUD_NAME = 'df4sudukf';
  var UPLOAD_PRESET = 'customer-photo-upload';
  var PORTRAIT_HANDLE = 'portrait-animalier-personnalise-canvas-encadre';

  if (window.location.pathname.indexOf(PORTRAIT_HANDLE) === -1) return;

  function injectUploadUI() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return setTimeout(injectUploadUI, 500);

    var submitBtn = form.querySelector('[type="submit"], .btn--add-to-cart, .product-form__submit, button[name="add"]');
    if (!submitBtn) return;

    submitBtn.disabled = true;
    submitBtn.dataset.originalText = submitBtn.textContent;
    submitBtn.textContent = '\uD83D\uDCF7 Uploadez d\'abord votre photo';

    var container = document.createElement('div');
    container.id = 'portrait-upload-container';
    container.innerHTML = '<div style="margin:20px 0;padding:20px;border:2px dashed #c9a96e;border-radius:12px;text-align:center;background:#faf8f5;">'
      + '<input type="file" id="portrait-photo-input" accept="image/jpeg,image/png,image/webp" style="display:none">'
      + '<input type="hidden" name="properties[_photo_url]" id="portrait-photo-url" value="">'
      + '<button type="button" id="portrait-upload-btn" style="background:#c9a96e;color:#fff;border:none;padding:14px 28px;border-radius:8px;font-size:16px;cursor:pointer;font-weight:600;">\uD83D\uDCF7 Uploade la photo de ton animal</button>'
      + '<p style="margin:10px 0 0;color:#666;font-size:13px;">JPG, PNG ou WebP \u2014 min 500\u00d7500 px \u2014 max 10 Mo</p>'
      + '<div id="portrait-upload-progress" style="display:none;margin-top:15px;"><div style="background:#eee;border-radius:4px;overflow:hidden;height:6px;"><div id="portrait-progress-bar" style="background:#c9a96e;height:100%;width:0%;transition:width 0.3s;"></div></div><p style="color:#666;font-size:12px;margin-top:5px;">Upload en cours...</p></div>'
      + '<div id="portrait-preview-container" style="display:none;margin-top:15px;"><img id="portrait-preview-img" style="max-width:280px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.15);"><p style="color:#2d7d46;font-weight:600;margin-top:8px;">\u2705 Photo re\u00e7ue ! Vous pouvez ajouter au panier.</p><button type="button" id="portrait-change-btn" style="background:none;border:1px solid #999;padding:6px 14px;border-radius:6px;font-size:13px;cursor:pointer;margin-top:5px;">Changer la photo</button></div>'
      + '</div>';

    submitBtn.parentNode.insertBefore(container, submitBtn);

    document.getElementById('portrait-upload-btn').addEventListener('click', function() {
      document.getElementById('portrait-photo-input').click();
    });

    var changeBtn = document.getElementById('portrait-change-btn');
    if (changeBtn) changeBtn.addEventListener('click', function() {
      document.getElementById('portrait-photo-input').click();
    });

    document.getElementById('portrait-photo-input').addEventListener('change', function(e) {
      var file = e.target.files[0];
      if (!file) return;

      if (['image/jpeg','image/png','image/webp'].indexOf(file.type) === -1) {
        alert('Format accept\u00e9 : JPG, PNG ou WebP');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        alert('Fichier trop volumineux (max 10 Mo)');
        return;
      }

      document.getElementById('portrait-upload-progress').style.display = 'block';
      document.getElementById('portrait-preview-container').style.display = 'none';

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', UPLOAD_PRESET);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/image/upload');

      xhr.upload.onprogress = function(ev) {
        if (ev.lengthComputable) {
          document.getElementById('portrait-progress-bar').style.width = Math.round((ev.loaded / ev.total) * 100) + '%';
        }
      };

      xhr.onload = function() {
        document.getElementById('portrait-upload-progress').style.display = 'none';
        if (xhr.status !== 200) { alert('Erreur upload. R\u00e9essayez.'); return; }
        var data = JSON.parse(xhr.responseText);
        if (data.width < 500 || data.height < 500) { alert('Image trop petite (min 500\u00d7500 px).'); return; }
        document.getElementById('portrait-photo-url').value = data.secure_url;
        document.getElementById('portrait-preview-img').src = data.secure_url;
        document.getElementById('portrait-preview-container').style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.originalText || 'Ajouter au panier';
      };

      xhr.onerror = function() {
        document.getElementById('portrait-upload-progress').style.display = 'none';
        alert('Erreur r\u00e9seau.');
      };

      xhr.send(formData);
    });

    form.addEventListener('submit', function(e) {
      if (!document.getElementById('portrait-photo-url').value) {
        e.preventDefault();
        alert('Veuillez d\'abord uploader une photo de votre animal.');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectUploadUI);
  } else {
    injectUploadUI();
  }
})();
